export const getContexts = (
  length: number,
  mobileContext: string | string[],
  desktopContext?: string | string[],
): { mobileContext: string[]; desktopContext: string[] } => {
  const mobile: string[] = Array.isArray(mobileContext)
    ? mobileContext
    : (Array(length).fill(mobileContext) as string[]);

  const desktop: string[] =
    desktopContext && Array.isArray(desktopContext)
      ? desktopContext
      : desktopContext
        ? // Passed a string, so create an array of the same string
          (Array(length).fill(desktopContext) as string[])
        : // Passed nothing, so return the mobile context
          mobile;

  return { mobileContext: mobile, desktopContext: desktop };
};
